import { api } from './request'

const payments = {
  // 获取支付记录列表
  list: (params) => api.get('/admin/payments', { params }),

  // 获取支付统计
  statistics: (params) => api.get('/admin/payments/statistics', { params }),

  // 获取单个支付记录详情
  get: (id) => api.get(`/admin/payments/${id}`),

  // 手动确认支付（用于线下支付）
  confirm: (id) => api.post(`/admin/payments/${id}/confirm`),

  // 导出支付记录
  export: (params) => api.get('/admin/payments/export', {
    params,
    responseType: 'blob'
  })
}

// 退款记录API
const refunds = {
  // 获取退款记录列表
  list: (params) => api.get('/admin/refunds', { params }),

  // 获取单个退款记录详情
  get: (id) => api.get(`/admin/refunds/${id}`),

  // 处理退款
  process: (id, data) => api.post(`/admin/refunds/${id}/process`, data)
}

export default {
  payments,
  refunds
}